import React from 'react';

import {useTranslation} from 'react-i18next';

import i18next from 'i18next';

export interface LabelProps {
    title?: string;
    label?: string;
    tlabel?: string;
}

export function translateLabel(props: LabelProps, defLabel?: string) {
    if (props.label)
        return i18next.t(props.label);
        
    if (props.title)
        return i18next.t(props.title);

    if (props.tlabel)
        return props.tlabel;

    if (defLabel)
        return i18next.t(defLabel);

    return '';
}


export function useTranslateLabel(props: LabelProps, defLabel?: string) {
    const [t] = useTranslation();  // We need this to trigger rerender

    let label = translateLabel(props, defLabel) as string;

    return [label, t];
}

